<template>
  <div>
    <div>
      <b-row no-gutters>
        <b-col>
          <DesignNav></DesignNav>
        </b-col>
      </b-row>
    </div>
    <div class="design-body content-body">
      <div class="content-inside mt-4 pb-5">
        <div style="margin-top: 1px">
          <span class="label-helper align-top">Web E-Store</span>
          <i class="guide-tooltip" id="customer-app"></i>
          <b-popover
            target="customer-app"
            triggers="hover"
            content="Create the basic design theme of your website."
          ></b-popover>
        </div>
        <b-row
          class="mt-4"
          :class="planId == 1 || planId == 2 ? 'disableContent' : ''"
        >
          <b-col cols="2">
            <router-link
              :to="
                planId != 1 && planId != 2
                  ? '/design/web/create-web-design'
                  : ''
              "
              class="btn create-page"
              v-b-tooltip.hover
              :title="planId == 1 || planId == 2 ? unavailableToPlan : ''"
            >
              <img src="@/assets/images/mechanics/add-inactive.svg" alt="Add" />
              <div class="text-primary">Create</div>
            </router-link>
          </b-col>
          <b-col cols="10" v-if="webDesigns">
            <b-row>
              <b-col
                class="mb-4"
                cols="4"
                v-for="(webDesign, index) in webDesigns.designs"
                :key="index"
              >
                <div class="col-container">
                  <b-row>
                    <b-col lg="5" class="pr-0">
                      <span
                        :class="[
                          'app-title ' +
                            (webDesign.published ? 'selected' : ''),
                        ]"
                      >
                        <img
                          height="15px"
                          src="@/assets/images/icons/web.svg"
                          alt="Web"
                          style="margin-right: 5px"
                        />
                        {{ webDesign.published ? "Published" : "Draft" }}
                      </span>
                    </b-col>
                    <b-col class="text-right">
                      <switches
                        v-model="webDesign.published"
                        @click.native="publishWebDesign(webDesign.uuid, index)"
                        theme="custom"
                        color="primary"
                        type-bold="true"
                        text-enabled=" "
                        text-disabled=" "
                        style="top: -13px"
                      ></switches>

                      <router-link
                        :to="'web/edit-web-design/' + webDesign.uuid"
                      >
                        <img
                          height="20px"
                          src="@/assets/images/achievement/action/edit.svg"
                          alt="Edit Icon"
                          style="margin-left: 5px"
                        />
                      </router-link>

                      <i
                        class="action-button"
                        @click="showModal(webDesign.uuid, webDesign.title)"
                      >
                        <img
                          src="@/assets/images/achievement/action/delete.svg"
                          alt="Delete Button"
                        />
                      </i>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="2">
                      <label
                        class="theme-span"
                        :style="
                          'background-color: ' +
                          webDesign.main_color +
                          '; color: ' +
                          webDesign.button_text_color
                        "
                        >Aa</label
                      >
                    </b-col>
                    <b-col style="margin-top: 8px; margin-left: 18px;">
                      <strong>{{ webDesign.title }}</strong>
                      <p>Last edited: {{ webDesign.updated_at }}</p>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-modal ref="delete-modal" title="Delete Customer Web Design">
          <p class="modal-main-message">
            Are you sure you want delete this Design?
          </p>
          <h3 class="modal-secondary-message">
            {{ designName }}
          </h3>
          <div slot="modal-footer">
            <b-btn
              variant="ghost"
              class="mr-1 btn-cancel"
              @click="hideModal()"
              >Cancel</b-btn
            >
            <b-btn
              variant="primary"
              class="ml-1"
              @click="handleDelete(designUuid)"
              >Yes, Delete</b-btn
            >
            <span class="modal-helper-message d-block mt-4"
              >Caution: This cannot be undone.</span
            >
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import permission from "@/services/user.permission";
import DesignNav from "./components/DesignNav";
import { mapState } from "vuex";
import Switches from "vue-switches";
export default {
  name: "design-nav",
  components: {
    DesignNav,
    Switches,
  },
  created() {
    this.getWebDesigns();
  },
  computed: {
    ...mapState("designs", {
      loading: (state) => state.loading,
      errors: (state) => state.errors,
      details: (state) => state.details,
      webDesigns: (state) => state.webDesigns,
    }),
  },
  data() {
    return {
      msg: "Design Nav",
      permission: permission,
      env: process.env.VUE_APP_MODE,
      designUuid: null,
      designName: null,
      planId: null
    };
  },
  methods: {
    async getWebDesigns() {
      await this.$store.dispatch("designs/getWebDesigns");
    },
    hideModal() {
      this.$refs["delete-modal"].hide();
    },
    showModal(uuid, title) {
      this.$refs["delete-modal"].show();
      this.designUuid = uuid;
      this.designName = title;
    },
    handleDelete(uuid) {
      this.$store.dispatch("designs/deleteWebDesign", uuid).then(() => {
        this.$store.dispatch("designs/getWebDesigns");
        this.designUuid = null;
        this.designName = null;
      });

      this.$refs["delete-modal"].hide();
    },
    async publishWebDesign(uuid, index) {
      let param = {
        uuid: uuid,
        published: !this.webDesigns.designs[index].published,
      };

      await this.$store.dispatch("designs/publishWebDesign", param).then(() => {
        this.$store.dispatch("designs/getWebDesigns");
      });
    },
  },
};
</script>

<style scoped>
</style>
